import React from 'react';
import { latePaymentStats } from '../../data/landingContent';
export function LatePaymentStats() {
  return <section id="late-payment" className="navy-texture scroll-mt-6 text-white" data-id="element-115" data-mp="2013r6pgbowuf">
      <div className="mx-auto max-w-6xl px-5 py-16 sm:px-8 sm:py-24" data-id="element-116" data-mp="24yvknnwm8r0q">
        <div className="grid gap-10 lg:grid-cols-[0.9fr_1.1fr] lg:gap-16" data-id="element-117" data-mp="29plmws9qwdr7">
          <div data-id="element-118" data-mp="29ryb3n63jkcp">
            <p className="text-xs font-bold uppercase tracking-[0.16em] text-[#4BE4FF]" data-id="element-119" data-mp="2eoyjw5ubz17i">
              At a glance
            </p>
            <h2 className="font-display mt-3 text-2xl font-bold uppercase leading-tight tracking-[0.02em] sm:text-[2.1rem]" data-id="element-120" data-mp="2ips5gskaw3x8">
              UK late payment culture at a glance.
            </h2>
            <p className="mt-5 text-sm leading-7 text-[#A6B6F8]" data-id="element-121" data-mp="2sozkdk6oo6mg">
              The late payment culture in the UK has significant implications
              for small and medium-sized enterprises.
            </p>
            <p className="mt-4 text-sm leading-7 text-[#A6B6F8]" data-id="element-122" data-mp="ybrkhe3up4ty">
              It is very common to find owners and managers spending a
              disproportionate amount of their time chasing late payments whilst
              trying to avoid cash flow problems. This can seriously restrict
              opportunities to grow, even pushing some businesses to the brink
              of insolvency.
            </p>
          </div>

          <dl className="grid grid-cols-2 gap-x-8 gap-y-8 sm:grid-cols-2" data-id="element-123" data-mp="1h68qm36g212k">
            {latePaymentStats.map(stat => <div key={stat.label} className="border-t border-[#A6B6F8]/40 pt-4" data-id="element-124" data-mp="28zhr9xky1aat">
                <dt className="text-3xl font-bold tracking-[-0.03em] text-[#4BE4FF] sm:text-4xl" data-id="element-125" data-mp="28xomyoxsz25z">
                  {stat.value}
                </dt>
                <dd className="mt-2 text-xs leading-5 text-[#A6B6F8]" data-id="element-126" data-mp="1zxrsu7sn9b3j">
                  {stat.label}
                </dd>
              </div>)}
          </dl>
        </div>
      </div>
    </section>;
}